import axios from 'axios';

// Customer UI must only call the Customer API endpoint.
// Base URL comes from env; fallback is relative /api so Nginx can proxy in production.
const API_BASE_URL = process.env.REACT_APP_CUSTOMER_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const locationService = {
  getAll: () => api.get('/locations/'),
  getById: (id) => api.get(`/locations/${id}/`),
  getTickets: (id) => api.get(`/locations/${id}/tickets/`),
  getAddons: (id) => api.get(`/locations/${id}/addons/`),
};

export const ticketService = {
  getAll: () => api.get('/tickets/'),
};

export const addonService = {
  getAll: () => api.get('/addons/'),
};

export const bookingService = {
  create: (data) => api.post('/bookings/', data),
  calculateTotal: (data) => api.post('/bookings/calculate_total/', data),
  getById: (id) => api.get(`/bookings/${id}/`),
};

export const promocodeService = {
  validate: (code) => api.post('/promocodes/validate/', { code }),
};

export const otpService = {
  send: (mobile_number) => api.post('/otp/send/', { mobile_number }),
  verify: (mobile_number, otp_code) => api.post('/otp/verify/', { mobile_number, otp_code }),
};

export const paymentService = {
  createOrder: (mobile_number, otp_code, booking_data) => 
    api.post('/payment/create-order/', { mobile_number, otp_code, booking_data }),
  callback: (razorpay_order_id, razorpay_payment_id, razorpay_signature, booking_id) =>
    api.post('/payment/callback/', {
      razorpay_order_id,
      razorpay_payment_id,
      razorpay_signature,
      booking_id,
    }),
};

export default api;
